import { render, staticRenderFns } from "./title-block.vue?vue&type=template&id=cfaa641a"
import script from "./title-block.vue?vue&type=script&lang=js"
export * from "./title-block.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports